// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-logo__wrapper[data-v-88ab9afe]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.error-logo__text[data-v-88ab9afe],.error-logo__wrapper[data-v-88ab9afe]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.error-logo__text[data-v-88ab9afe]{-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start}", ""]);
// Exports
module.exports = exports;
